import env from './environment'

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.baseURL = env.API_URL;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: env.BROADCAST_DRIVER,
  key: env.PUSHER_APP_KEY,
  cluster: env.PUSHER_APP_CLUSTER,
  encrypted: env.PUSHER_ENCRYPTED,
  authEndpoint: `${env.API_URL}/broadcasting/auth`
});



// WEBPACK FOOTER //
// ./src/bootstrap.js